import * as React from "react";
import { BrowserRouter } from "react-router-dom";
import AnalyticsPageTracker from "./components/AnalyticsPageTracker";

import "./app.css";

import { OfflineManager } from "./pages/offline/OfflineManager";
import { UserProvider } from "./components/UserProvider";
import { AppConfigProvider } from "./components/AppConfigProvider";
import { OfflineStatusProvider } from "./components/OfflineStatusProvider";
import Mui3WidthProvider from "./components/Mui3WidthProvider";
import AppRoutes from "./AppRoutes";

interface AppProps {
	baseUrl: string;
}

function App(props: AppProps) {
	return (
		<BrowserRouter basename={props.baseUrl}>
			<OfflineStatusProvider>
				<AppConfigProvider>
					<UserProvider>
						<AnalyticsPageTracker>
							<OfflineManager>
								<Mui3WidthProvider>
									<AppRoutes />
								</Mui3WidthProvider>
							</OfflineManager>
						</AnalyticsPageTracker>
					</UserProvider>
				</AppConfigProvider>
			</OfflineStatusProvider>
		</BrowserRouter>
	);
}

export default App;
